import type { Kiosk } from '@gozoki/api-types'
import type { UseQueryResult } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { fetchCheckinKiosks } from '../queries/checkinKiosk.queries'

export const useCheckinKiosks = (storeId: number): UseQueryResult<Kiosk[], unknown> =>
  useQuery({
    queryKey: ['checkin', storeId],
    queryFn: () => fetchCheckinKiosks(storeId),
  })

export const useCheckinKiosk = (storeId: number): UseQueryResult<Kiosk[], unknown> =>
  useQuery({
    queryKey: ['checkin', storeId],
    queryFn: () => fetchCheckinKiosks(storeId),
  })
